import { observer } from 'mobx-react';
import { autoinject, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { InfrastructureDashboard } from './InfrastructureDashboard';

export interface IInfrastructureViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class InfrastructureView extends React.Component<IInfrastructureViewProps> {
    public render() {
        return (
            <>
                <Title>Infrastructure</Title>

                <SubTopBar>
                    <span className="nav-link fw-bold d-inline-block">Kubernetes Management</span>
                </SubTopBar>

                <InfrastructureDashboard />
            </>
        );
    }
}
